import React, { FunctionComponent } from 'react'
import { Route, Switch, RouteComponentProps } from 'react-router-dom'

import { MyFiReports } from '../../pages'
import { Err404 } from '../../components'

interface MyFiReportsRouterProps
  extends RouteComponentProps<{ page: string }> {}

const MyFiReportsRouter: FunctionComponent<MyFiReportsRouterProps> = ({
  match,
}) => (
  <Switch>
    <Route path={`${match.path}/myfi-reports`} component={MyFiReports} />
    <Route path={`${match.path}`} component={MyFiReports} />
    <Route component={Err404} />
  </Switch>
)

export default MyFiReportsRouter
